import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapturumSharedModule } from '@capturum/ui/api';
import { CapturumButtonModule } from '@capturum/ui/button';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-field-with-add-button-wrapper',
  template: `
    <div class="form-group" [class.has-error]="showError">
      @if (props.translateLabel && props.hideLabel !== true) {
        <label [attr.for]="id" class="d-block">
          {{ props.translateLabel | observablePipe | async }}
          @if (props.required && props.hideRequiredMarker !== true) {
            <span>*</span>
          }
        </label>
      }

      <div class="form-control-wrapper">
        <ng-template #fieldComponent />

        <div class="add">
          @if (props.onAdd) {
            <cap-button
              [label]="props.addButton?.label"
              [icon]="props.addButton?.icon || 'mynaui-plus'"
              [disabled]="props.disabled"
              [styleClass]="props.addButton?.styleClass || 'primary'"
              (onClick)="props.onAdd()" />
          }
        </div>
      </div>

      @if (showError) {
        <div class="invalid-feedback" [style.display]="'block'">
          <cap-validator [control]="field.formControl" />
        </div>
      }

      @if (props.description) {
        <small class="form-text text-muted">{{ props.description | observablePipe | async }}</small>
      }
    </div>
  `,
  imports: [CapturumSharedModule, FormsModule, ReactiveFormsModule, AsyncPipe, CapturumButtonModule],
})
export class FormlyFieldWithAddButtonWrapperComponent extends FieldWrapper {}
